import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as C } from "../../_mixins/use-rtl.js";
import { ensureSupportFlexGap as R } from "./utils.js";
import j from "../../_mixins/use-config.js";
import b from "../../_mixins/use-theme.js";
import G from "../styles/light.js";
import { createKey as I } from "../../_utils/cssr/index.js";
import { getGap as M, depx as w } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { flatten as P } from "../../_utils/vue/flatten.js";
import { getSlot as T } from "../../_utils/vue/get-slot.js";
import { defineComponent as A, computed as E, h as x, Comment as L } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const O = Object.assign(Object.assign({}, b.props), {
  align: String,
  justify: {
    type: String,
    default: "start"
  },
  inline: Boolean,
  vertical: Boolean,
  reverse: Boolean,
  size: {
    type: [String, Number, Array],
    default: "medium"
  },
  wrapItem: {
    type: Boolean,
    default: !0
  },
  itemClass: String,
  itemStyle: [String, Object],
  wrap: {
    type: Boolean,
    default: !0
  },
  // internal
  internalUseGap: {
    type: Boolean,
    default: void 0
  }
}), Q = A({
  name: "Space",
  props: O,
  setup(e) {
    const {
      mergedClsPrefixRef: a,
      mergedRtlRef: f
    } = j(e), g = b("Space", "-space", void 0, G, e, a), t = C("Space", f, a);
    return {
      useGap: R(),
      rtlEnabled: t,
      mergedClsPrefix: a,
      margin: E(() => {
        const {
          size: r
        } = e;
        if (Array.isArray(r))
          return {
            horizontal: r[0],
            vertical: r[1]
          };
        if (typeof r == "number")
          return {
            horizontal: r,
            vertical: r
          };
        const {
          self: {
            [I("gap", r)]: u
          }
        } = g.value, {
          row: n,
          col: d
        } = M(u);
        return {
          horizontal: w(d),
          vertical: w(n)
        };
      })
    };
  },
  render() {
    const {
      vertical: e,
      reverse: a,
      align: f,
      inline: g,
      justify: t,
      itemClass: r,
      itemStyle: u,
      margin: n,
      wrap: d,
      mergedClsPrefix: h,
      rtlEnabled: v,
      useGap: l,
      wrapItem: $,
      internalUseGap: z
    } = this, p = P(T(this), !1);
    if (!p.length)
      return null;
    const S = `${n.horizontal}px`, m = `${n.horizontal / 2}px`, B = `${n.vertical}px`, i = `${n.vertical / 2}px`, s = p.length - 1, c = t.startsWith("space-");
    return x("div", {
      role: "none",
      class: [`${h}-space`, v && `${h}-space--rtl`],
      style: {
        display: g ? "inline-flex" : "flex",
        flexDirection: (() => e && !a ? "column" : e && a ? "column-reverse" : !e && a ? "row-reverse" : "row")(),
        justifyContent: ["start", "end"].includes(t) ? `flex-${t}` : t,
        flexWrap: !d || e ? "nowrap" : "wrap",
        marginTop: l || e ? "" : `-${i}`,
        marginBottom: l || e ? "" : `-${i}`,
        alignItems: f,
        gap: l ? `${n.vertical}px ${n.horizontal}px` : ""
      }
    }, !$ && (l || z) ? p : p.map((y, o) => y.type === L ? y : x("div", {
      role: "none",
      class: r,
      style: [u, {
        maxWidth: "100%"
      }, l ? "" : e ? {
        marginBottom: o !== s ? B : ""
      } : v ? {
        marginLeft: c ? t === "space-between" && o === s ? "" : m : o !== s ? S : "",
        marginRight: c ? t === "space-between" && o === 0 ? "" : m : "",
        paddingTop: i,
        paddingBottom: i
      } : {
        marginRight: c ? t === "space-between" && o === s ? "" : m : o !== s ? S : "",
        marginLeft: c ? t === "space-between" && o === 0 ? "" : m : "",
        paddingTop: i,
        paddingBottom: i
      }]
    }, y)));
  }
});
export {
  Q as default,
  O as spaceProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/space/src/Space.js
// module id = 1694
// module chunks = 41